import { LogEventModel } from "../../../../data-model/logEventModel";
import { ModalId } from "../../../../enums/modalId";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";

import { apiWorkerManager } from "../../../../workerManagers/workerManager";
export const handleViewNccnGuidelines = (
  dispatch: AppDispatch,
  items: any,
  eventData: LogEventModel,
) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION,
      metaData: {
        items: items,
      },
    }),
  );
  apiWorkerManager.enqueueAndProcess(eventData);
};
